export default __webpack_public_path__ + "static/media/Simscale.c82fef9a.png";